import { Component, OnInit } from '@angular/core';
import { AngularFirestore } from '@angular/fire/firestore';
import { concat, Observable } from 'rxjs';
import { combineAll, concatAll, concatMap, concatMapTo, first, groupBy, map, mergeAll, mergeMap, mergeMapTo, reduce, tap } from 'rxjs/operators';
import { Deal } from 'src/app/cart/services/deal.service';

@Component({
   selector: 'app-deals',
   templateUrl: './deals.component.html',
   styleUrls: ['./deals.component.css'],
})
export class DealsComponent implements OnInit {
   deals$: Observable<Deal[]>;
   transactions$: Observable<Tlist[]>;
   transactions: Tlist[];

   transactionTypes: string[];

   groupedTypes$: Observable<any>;

   constructor(private afs: AngularFirestore) {}

   ngOnInit(): void {
      this.deals$ = this.fetchDeals();
      // this.transactions$ =
      // this.transactions$ = 
      this.convertDealToTransaction3();
      // console.log(this.transactions);
      // this.transactionTypes = this.transactions.map(trans => trans.type )
      // let groupedSales = this.groupBy(this.transactions$, 'type')

      // type'ları bulur
      // this.groupedTypes$ = this.transactions$.pipe(
      //    map(trans => Object.keys( this.groupBy(trans, 'type'))
      //    ),
      //    // tap(vals => vals.)
         
      // );

      this.groupedTypes$ = this.transactions$.pipe(
         map(trans => this.convertObjToArray(this.groupBy(trans, 'type', 'amount'))  
         ),
         // tap(vals => vals.)
         
      );

      // this.transactions$.pipe(
      //    reduce()
      // )

      // this.groupedTypes$ =
      // this.transactions$.pipe(
      //    groupBy(trans => trans.map(trn => trn.type))
      // )

      
   }

   fetchDeals(): Observable<Deal[]> {
      const today = new Date();
      const dayesterdayte = Date.parse(today.toJSON()) - (24*60*60*1000);
      const yesterday = new Date(dayesterdayte);

      console.log('dayesterdayte: ', dayesterdayte);
      console.log('yesterday: ', yesterday.toJSON());


      const onlyDate = new Date(today.getFullYear());


      console.log('today: ', today);
      console.log('parse: ', Date.parse(today.toJSON().slice(0, 10)) + (24*60*60*100));
      console.log('toLocaleDateString: ', today.toLocaleDateString('tr-TR'));
      console.log('toLocaleString: ', today.toLocaleString());
      console.log('toISOString: ', today.toISOString());
      console.log('toJSON: ', today.toJSON().slice(0, 10));
      console.log('toDateString: ', today.toDateString());
      console.log('toUTCString: ', today.toUTCString());


      
      return this.afs
         .collection<Deal>('Deals', (ref) => ref.where('timestamp', '>=', new Date(yesterday.toJSON().slice(0, 10))))
         .valueChanges()
         .pipe(first());
   }

   groupBy(objectArray: {}[], propGr: string, propSum) {
      return objectArray.reduce( (acc, obj, i, arr) => {
        let key = obj[propGr]
        if (!acc[obj[propGr]]) {
          acc[obj[propGr]] = {[propGr]: obj[propGr], sum: 0};
        }
        acc[obj[propGr]].sum += +obj[propSum];
        return acc
      }, {})
    }

   convertObjToArray(obj: object) {
      let myArr = [];
      for(let prop in obj) {
         myArr.push(obj[prop]); 
      }
      return myArr;
   }

   convertDealToTransaction3() {
   this.transactions$ =
    this.deals$
       .pipe(
          map(deals => deals.map((deal, i) => {
            return deal.transactions.map(trn => {
               return {
                  code: deals[i].dealCode,
                  type: trn.type,
                  amount: trn.amount
               }
            })
          }).reduce((acc, curr) => acc.concat(curr), [])),
         //  tap(arrs => {
         //     let array: Tlist[] = [] ;
         //     arrs.forEach(arr => arr.forEach(elm => array.push(elm)));
         //    this.transactions = array;
         //    console.log(array);
         //    // return array;
         //  } )
       )
      //  .subscribe();
 }

   convertDealToTransaction2() {
      
      // this.transactions = [];
      return this.deals$
         .pipe(
            map(deals => {
              // let transactions: Tlist[];
              return deals.map((deal, i) => deal.transactions.map(trans => {
                const type = trans.type;
                const amount = trans.amount;
                const code = deals[i].dealCode;
                // transactions.push( {code: code, type: type, amount: amount});
                console.log({code: code, type: type, amount: amount});
                return {code: code, type: type, amount: amount};
              }));
              // return transactions;
            }),
            combineAll()
            // concatAll(vals => )
            
            
         )
        //  .subscribe();
   }

   convertDealToTransaction() {
      // this.transactions$ =
      this.transactions = [];
      return this.deals$
         .pipe(
            // map(deals => {
            //   let transactions: Tlist[];
            //   return deals.map((deal, i) => deal.transactions.map(trans => {
            //     const type = trans.type;
            //     const amount = trans.amount;
            //     const code = deals[i].dealCode;
            //     // transactions.push( {code: code, type: type, amount: amount});
            //     return {code: code, type: type, amount: amount}
            //   }));
            //   return transactions;
            // }),
            map((deals) =>
               deals.map((deal) => {
                  return {
                     code: deal.dealCode,
                     transactions: deal.transactions,
                  };
               })
            ),
            tap((vals) => {
               // let transrows = [];
               vals.forEach((val, i) =>
                  val.transactions.forEach((trans) => {
                     const row = {
                        code: vals[i].code,
                        type: trans.type,
                        amount: trans.amount,
                     };
                     this.transactions.push(row);
                     // console.log('transrows: ', row)
                     // return transrows;
                  })
               );
            })
         )
         .subscribe();
   }
}

export interface Tlist {
   code: string;
   type: string;
   amount: number;
}
